/*
 * @Author: your name
 * @Date: 2022-03-16 13:45:12
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-24 14:17:26
 * @Description: file content
 */

const state = {
  // 奖品名字
  prizeNames: [],
  // 活动结束时间
  effectiveEndTime: "",
  // 活动说明
  remark: "",
  // 是否已参加活动
  joinStatus: false,
  // 活动是否已开奖
  status: false,
  circleOptions: {
    displayText: "参与抽奖",
    prized_text: "",
    topCircleFill: "#fab33b",
    bottomCircleFill: "rgba(250, 179, 59, 0.2)",
  },
  // 客户中奖内容是否是 非谢谢参与
  // 是否是有效中奖内容(goods, redpacket )
  prized: false,
  prizer: {}, // 中奖者的所有信息， 包括奖品，和用户id 以及奖品名字
  prizeModalInfo: {}
  // {fonts: [{text:''}]}
};

const mutations = {
  UPDATE_PRIZE_MODAL(state, data) {
    state.prizeModalInfo = {
      fonts: [{
        text: `${data[0]}:${data[1]}`
      }]
    }
  },
  UPDATE_PRIZENAMES(state, data) {
    state.prizeNames = data.prizeNames;
  },
  UPDATE_EFFECTIVE_END_TIME(state, data) {
    state.effectiveEndTime = data.effectiveEndTime;
  },
  UPDATE_REMARK(state, data) {
    state.remark = data.remark;
  },
  UPDATE_JOIN_STATUS(state, data) {
    state.joinStatus = data.joinStatus;
  },
  UPDATE_OPENED_STATUS(state, data) {
    state.status = data.status;
  },
  OPTION_WAIT_OPEN_PRIZE(state, data) {
    state.circleOptions.displayText = "待开奖";
    state.circleOptions.topCircleFill = "rgb(255, 0,39)";
  },
  OPEN_PRIZE(state, data) {
    state.circleOptions.displayText = "恭喜！您已中奖";
    state.circleOptions.prized_text = data.prize;
    state.circleOptions.topCircleFill = "rgb(255, 0,39)";
  },
  OPTION_THANKS(state, data) {
    state.circleOptions.displayText = "谢谢参与";
    state.circleOptions.topCircleFill = "rgb(255, 0,39)";
  },
  CHANGE_PRIZED(state, data) {
    state.prized = data.prized;
  },
  OPTION_LUCKY_END(state, data) {
    state.circleOptions.displayText = "活动已结束";
    state.circleOptions.topCircleFill = "rgb(255, 0,39)";
  },
  UPDATE_PRIZER(state, data) {
    state.prizer = data.prizer;
  },
  RED_PACKET_TIPS(state, data) {
    state.circleOptions.displayText = "恭喜中奖!";
    state.circleOptions.prized_text = "红包已发放";
    state.circleOptions.topCircleFill = "rgb(255, 0,39)";
  },
}

export default {
  namespaced: true,
  state,
  mutations,

};
/*




*/